import createIcon from '../../createIcon';

/**
 * @component @name ViewAgenda
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgMTNINUMzLjkgMTMgMyAxMy45IDMgMTVWMTlDMyAyMC4xIDMuOSAyMSA1IDIxSDE5QzIwLjEgMjEgMjEgMjAuMSAyMSAxOVYxNUMyMSAxMy45IDIwLjEgMTMgMTkgMTNaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTkgM0g1QzMuOSAzIDMgMy45IDMgNVY5QzMgMTAuMSAzLjkgMTEgNSAxMUgxOUMyMC4xIDExIDIxIDEwLjEgMjEgOVY1QzIxIDMuOSAyMC4xIDMgMTkgM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ViewAgenda = createIcon('ViewAgenda', [
  [
    'path',
    {
      d: 'M19 13H5C3.9 13 3 13.9 3 15V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V15C21 13.9 20.1 13 19 13Z',
      key: 'zd4i7c',
    },
  ],
  [
    'path',
    {
      d: 'M19 3H5C3.9 3 3 3.9 3 5V9C3 10.1 3.9 11 5 11H19C20.1 11 21 10.1 21 9V5C21 3.9 20.1 3 19 3Z',
      key: '1nqw9k',
    },
  ],
]);

export default ViewAgenda;
